// KPI 생산실적등록 관련 상수 정의

/**
 * 도움말 모달 메시지
 */
export const helpModalMessages = {
  title: 'KPI 생산실적등록 도움말',
  paragraphs: [
    '• KPI 생산실적등록은 센서와 연결된 설비에 대해 독립적으로 생산실적을 등록하는 화면입니다.',
    '• 각 설비별로 개별 등록 카드가 제공되며, 실시간으로 생산실적을 입력할 수 있습니다.',
    '• 검색 조건을 통해 특정 공장, 라인, 설비로 필터링하여 조회할 수 있습니다.',
    '• 제품 선택, 창고 지정, 양품/불량 수량 입력은 필수 항목입니다.',
    '• 불량수량이 0보다 크면 불량정보를 상세히 등록해야 합니다.',
    '• 불량정보의 수량 합계는 불량수량과 일치해야 합니다.',
    '• 생산 시작시간은 종료시간보다 빨라야 합니다.',
    '• 저장 후 해당 설비의 폼이 자동으로 초기화됩니다.'
  ]
};

/**
 * 모바일 도움말 모달 메시지
 */
export const MobileHelpModalMessages = {
  title: 'KPI 생산실적등록',
  paragraphs: [
    'KPI 생산실적등록은 센서와 연결된 설비에 대해 독립적으로 생산실적을 등록하는 화면입니다.',
    '제품 선택, 창고 지정, 양품/불량 수량 입력은 필수 항목입니다.',
    '불량수량이 0보다 크면 불량정보를 상세히 등록해야 합니다.',
    '불량정보의 수량 합계는 불량수량과 일치해야 합니다.',
    '저장 후 해당 설비의 폼이 자동으로 초기화됩니다.'
  ]
};

/**
 * 하단 정보 메시지
 */
export const bottomInfoMessages = [
  '• 센서에 연결된 설비만 표시됩니다.',
  '• 각 설비별로 독립적인 생산실적 등록이 가능합니다.',
  '• 불량수량이 있는 경우 반드시 불량정보를 등록해주세요.',
  '• 저장 후 폼이 자동으로 초기화됩니다.'
];

/**
 * 불량 유형 목록
 */
export const DEFECT_TYPES = [
  { value: 'RCV', label: '입고/원자재 불량' },
  { value: 'PRO', label: '가공/공정 불량' },
  { value: 'ASM', label: '조립 불량' },
  { value: 'FIN', label: '후공정/마감 불량' },
  { value: 'INP', label: '검사/측정 불량' },
  { value: 'ETC', label: '기타 불량' }
];

/**
 * 폼 기본값
 */
export const FORM_DEFAULT_VALUES = {
  factoryId: '',
  lineId: '',
  equipmentId: '',
  dateRange: {
    startDate: null,
    endDate: null
  }
};

/**
 * 유효성 검증 메시지
 */
export const VALIDATION_MESSAGES = {
  REQUIRED_PRODUCT: '제품을 선택해주세요',
  REQUIRED_WAREHOUSE: '창고를 선택해주세요',
  INVALID_QUANTITY: '생산수량(양품+불량)은 0보다 커야 합니다',
  NEGATIVE_QUANTITY: '수량은 음수가 될 수 없습니다',
  REQUIRED_DATE: '생산 시작/종료 시간을 입력해주세요',
  INVALID_DATE_RANGE: '종료시간이 시작시간보다 빨랄 수 없습니다',
  DEFECT_QTY_MISMATCH: (defectInfoSum, defectQty) => 
    `불량정보 수량 합계(${defectInfoSum})가 불량수량(${defectQty})과 일치하지 않습니다`,
  INCOMPLETE_DEFECT_INFO: '불량정보를 모두 입력해주세요'
};

/**
 * 알림 메시지
 */
export const ALERT_MESSAGES = {
  SAVE_SUCCESS:`설비의 생산실적이 저장되었습니다. KPI 지표 반영을 위해서는 반드시 출하등록 처리해주세요.`,
  SAVE_ERROR: '생산실적 저장 중 오류가 발생했습니다.',
  VALIDATION_ERROR: '모든 필수 항목을 올바르게 입력해주세요.',
  LOAD_ERROR: 'KPI 설비 정보를 불러오는데 실패했습니다.'
};